import React from "react";
import './c29_il_tuo_futuro.scss';
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import { isMobileOnly } from "react-device-detect";
import { insertHtml } from "../../utils/dom";

class IlTuoFuturo extends TemplateComponent {
    constructor(props) {
        super(props);
        this.futuroRef = React.createRef();
        this.state = {
            isHidden: false,
        };
    };

    playFuturoVideo = () => {
        this.futuroRef.current.play();
        this.setState({
            isHidden: true
        })
    }

    componentRender(data) {
        return (
            <div id={!isMobileOnly ? 'il-tuo-futuro' : 'il-tuo-futuro-mob'}>
                {data.component_title && <h3 className="component-title">{data.component_title}</h3>}
                <div className="container-fluid">
                    <div className="row">
                        <div className="futuro-card">
                            <div className="container">
                                <div className="row">
                                    <div className="futuro-title">{data.title}</div>
                                </div>
                                <div className="row">
                                    <div className={!isMobileOnly ? 'col' : 'col-12'}>
                                        {data.video
                                            ?
                                            <div className="futuro-img-container">
                                                <video className="video h-100" ref={this.futuroRef}>
                                                    <source src={data.video} type="video/mp4" />
                                                </video>
                                                {!this.state.isHidden &&
                                                    <button className="futuro-video-player-button"
                                                        onClick={this.playFuturoVideo.bind(this)}>
                                                        <div className="futuro-triangle" />
                                                    </button>}
                                            </div>
                                            :
                                            <div className="futuro-img-container">
                                                <img className="futuro-img" src={data.image} alt="Luiss.it" />
                                            </div>
                                        }
                                    </div>
                                    <div className={!isMobileOnly ? 'col' : 'col-12 bottom-space'}>
                                        <div className={data.btn_title ? 'futuro-content-btn' : 'futuro-content'} {...insertHtml(data.content)} />
                                        {data.btn_title ?
                                            <a href={data.btn_url}>
                                                <button className={!isMobileOnly ? 'text-btn' : 'text-btn-mob'}>{data.btn_title}</button>
                                            </a> : null}
                                        {(data.cta_url_1 || data.cta_url_2) && <div className="row footer-cta">
                                            {data.cta_url_1 && <a href={data.cta_url_1} className="col link-cta">{data.cta_label_1}</a>}
                                            {data.cta_url_2 && <a href={data.cta_url_2} className="col link-cta">{data.cta_label_2}</a>}
                                        </div>}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default IlTuoFuturo;
